import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import getCfg from '@/config/index'

// 创建axios实例
const service = axios.create({
  baseURL: getCfg('VUE_APP_BASE_API'), // api的base_url
  timeout: 100000, // 请求超时时间
  withCredentials: true
})
// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['X-Token'] = getToken() // 让每个请求携带token
  }
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错
  */
    const res = response.data
    // 用于跳转
    if (res.code === 40003) {
      // MessageBox.alert('请使用新域名登录，点击跳转', '提示', {
      //   confirmButtonText: '跳转',
      //   callback: action => {
      //     window.location.href = 'https://zy-ris.rimagdata.com/'
      //   }
      // })
      MessageBox.confirm('请使用新域名登录，点击跳转', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.location.href = 'https://zy-ris.rimagdata.com/'
      })
      return false
    } else if (res.code === 50001 || res.code === 50010) {
      // 专用于密码过期
      return response.data
    } else if (res.code !== 20000) {
      if (res.code === 50002) {
        const num = Number(res.message)
        if (num >= 5) {
          Message.error('您的密码已经被锁定，请30分钟后在重试。')
        } else if (num >= 3) {
          Message.error('您当前密码输入错误' + num + '次，输错5次账号将被锁定，请谨慎输入！')
        } else {
          Message.error('用户名或密码输入错误，请重新输入！')
        }
        return false
      }
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    Message({
      message: '连接服务超时，请您检查网络重试',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
